/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many options can I add?`)
};

const es_dw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuántas opciones puedo añadir?`)
};

const de_dw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele Optionen kann ich hinzufügen?`)
};

const nl_dw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveel opties kan ik toevoegen?`)
};

const fr_dw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien d'options puis-je ajouter ?`)
};

const it_dw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quante opzioni posso aggiungere?`)
};

const pt_br2_dw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantas opções posso adicionar?`)
};

const pt_dw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantas opções posso adicionar?`)
};

const ja_dw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いくつまで選択肢を追加できますか?`)
};

const zh_dw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我最多能添加多少个选项？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dw_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dw_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dw_faq_q2", locale)
	if (locale === "en") return en_dw_faq_q2(inputs)
	if (locale === "es") return es_dw_faq_q2(inputs)
	if (locale === "de") return de_dw_faq_q2(inputs)
	if (locale === "nl") return nl_dw_faq_q2(inputs)
	if (locale === "fr") return fr_dw_faq_q2(inputs)
	if (locale === "it") return it_dw_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_dw_faq_q2(inputs)
	if (locale === "pt") return pt_dw_faq_q2(inputs)
	if (locale === "ja") return ja_dw_faq_q2(inputs)
	return zh_dw_faq_q2(inputs)
};